import React from "react";
import styled from "styled-components";
import _layout from "./layout";
import fb from "../images/facebook.svg";
import vk from "../images/vk.svg";
import instagram from "../images/instagram.svg";
import twitter from "../images/twitter.svg";
import youtube from "../images/youtube.svg";
import googlePlay from "../images/googlePlay.svg";
import appStore from "../images/appStore.svg";

const FooterWrapper = styled.div`
  background: #fff7e6;
  position: relative;
  z-index: 1;
`;

const Layout = styled(_layout)`
  margin-bottom: 0;
  padding: 32px;
`;

const SocialImgWrapper = styled.a`
  display: inline-block;
  margin-right: 16px;
  transition: 0.2s;

  &:hover {
    opacity: 0.6;
  }
`;

const SubHeader = styled.div`
  color: #595959;
  font-size: 12px;
  margin-bottom: 13px;
`;

const LinksWrapper = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 860px) {
    width: auto;
  }

  a {
    display: inline-block;
    margin-bottom: 8px;
  }
`;

const AllLinksWrapper = styled.div`
  display: flex;

  @media (max-width: 860px) {
    display: block;
  }
`;

const SubLinksWrapper = styled.div`
  margin-right: 20px;

  @media (max-width: 860px) {
    margin-bottom: 16px;
  }
`;

const AppLinksWrapper = styled(SocialImgWrapper)`
  margin-right: 8px;
`;

export default function Footer() {
  return (
    <>
      <FooterWrapper>
        <Layout>
          <AllLinksWrapper>
            <LinksWrapper>
              <a href="https://mybook.ru/about/" target="_blank">
                Что такое MyBook
              </a>
              <a href="https://mybook.ru/payments/" target="_blank">
                Купить подписку
              </a>
              <a href="https://mybook.ru/l/help/" target="_blank">
                Помогите MyBook стать лучше
              </a>
            </LinksWrapper>
            <LinksWrapper>
              <a href="https://mybook.ru/partners/" target="_blank">
                Сотрудничество с MyBook
              </a>
              <a
                href="https://mybook.ru/payments/activate_gift/"
                target="_blank"
              >
                Ввести подарочный код
              </a>
              <a href="https://mybook.ru/b2b/" target="_blank">
                Библиотека для компаний
              </a>
            </LinksWrapper>
            <LinksWrapper>
              <a href="https://mybook.ru/help/" target="_blank">
                Помощь
              </a>
              <a href="https://mybook.ru/about/offer/" target="_blank">
                Публичная оферта
              </a>
              <a href="https://mybook-story.ru/" target="_blank">
                MyBook: Истории
              </a>
            </LinksWrapper>
          </AllLinksWrapper>
        </Layout>
      </FooterWrapper>
      <Layout>
        <AllLinksWrapper>
          <SubLinksWrapper>
            <SubHeader> Следите за новостями</SubHeader>
            <div>
              <SocialImgWrapper href="https://vk.com/mybook_ru" target="_blank">
                <img src={vk} alt="" />
              </SocialImgWrapper>
              <SocialImgWrapper href="" target="_blank">
                <img src={fb} alt="https://www.facebook.com/MyBookRu" />
              </SocialImgWrapper>
              <SocialImgWrapper
                href="https://www.instagram.com/mybookru/"
                target="_blank"
              >
                <img src={instagram} alt="" />
              </SocialImgWrapper>
              <SocialImgWrapper href="" target="_blank">
                <img src={twitter} alt="https://twitter.com/mybookru" />
              </SocialImgWrapper>
              <SocialImgWrapper
                href="https://www.youtube.com/channel/UCUGmk72YLzJW158J522b5Yg"
                target="_blank"
              >
                <img src={youtube} alt="" />
              </SocialImgWrapper>
            </div>
          </SubLinksWrapper>
          <SubLinksWrapper>
            <SubHeader>Скачайте приложение</SubHeader>
            <div>
              <AppLinksWrapper
                href="https://redirect.appmetrica.yandex.com/serve/674048688460421021/?pagetype=site_footer"
                target="_blank"
              >
                <img src={appStore} alt="" />
              </AppLinksWrapper>
              <AppLinksWrapper
                href="https://redirect.appmetrica.yandex.com/serve/97588024321320240/?pagetype=site_footer"
                target="_blank"
              >
                <img src={googlePlay} alt="" />
              </AppLinksWrapper>
            </div>
          </SubLinksWrapper>
        </AllLinksWrapper>
      </Layout>
    </>
  );
}

// Что такое MyBook
// Купить подписку
// Помогите MyBook стать лучше
// Сотрудничество с MyBook
// Ввести подарочный код
// Библиотека для компаний
// Помощь
// Условия использования
// Публичная оферта
// MyBook: Истории
